import React from "react";
import PropTypes from "prop-types";
import { Segment } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";

var humanFormat = require("human-format");
import { customdecodeURIComponent } from "../../common/Utils";
const NeighborhoodsList = ({
  itemData,
  href,
  prev,
  active,
  header,
  getData,
  customclass,
  ispage,
  isEnabled,
  seeFullListLink,
  ...props
}) => {
  let data = itemData.length;
  let page_size = ispage === "flyer" ? 2 : 3;
  let indexdata = (active - 1) * page_size;

  return (
    <div>
      <Segment
        basic
        //style={{ paddingLeft: 0, paddingRight: 0 }}
        className="nh_lists"
      >
        {itemData
          .slice(indexdata)
          .slice(0, page_size)
          .map((item, index) => {
            let npiscore = 0;
            let valuescore = 0;
            let indexdataid = itemData.findIndex(
              (itemData) => itemData.id === item.id
            );
            // /**NPI CALCULATION START */
            // let school_val = 40;
            // let crime_val = 40;
            // let walk_val = 20;
            // let town_val = 0;
            // let curb_val = 0;
            // let com_val = 0;

            // let w_sum = school_val + crime_val + walk_val + town_val + curb_val + com_val;

            // let w1 = school_val/w_sum //school
            // let w2 = crime_val/w_sum //safery
            // let w3 = walk_val/w_sum //walkability
            // let w4 = town_val/w_sum //town
            // let w5 = curb_val/w_sum //curb
            // let w6 = com_val/w_sum //community

            // let maxschoolfacor = 10.0;
            // let maxwalkfacor = 10.0;
            // let maxsafefacor = 10.0;
            // let maxtownfacor = 10.0;
            // let maxcurbfacor = 10.0;
            // let maxcomfacor = 10.0;

            // let finalresultnpi = 0;

            // let  npi_npiscore = 0;
            // let  npi_valuescore = 0;
            // let npi_schoolscore = 0;
            // let npi_crimescore = 0;
            // let npi_walkscore = 0;
            // if(item.school){
            //   npi_schoolscore = item.school;
            // }
            // if(item.crime){
            //   npi_crimescore = item.crime;
            // }
            // if(item.walkability){
            //   npi_walkscore = item.walkability;
            // }

            // let s1 = parseFloat(npi_schoolscore).toFixed(1)/maxsafefacor;
            // let s2 = parseFloat(npi_crimescore).toFixed(1)/maxschoolfacor;
            // let s3 = parseFloat(npi_walkscore).toFixed(1)/maxwalkfacor;
            // let s4 = 0;
            // let s5 = 0;
            // let s6 = 0;

            // npiscore = ( (w1*s1) + (w2*s2) + (w3*s3) + (w4*s4) + (w5*s5) + (w6*s6)).toFixed(1) *10

            // /**NPI CALCULATION WRAP */
            npiscore = item.npi;
            npiscore = npiscore = Number(
              ((item.npi / 100) * 5).toFixed(2)
            ).toFixed(1);
            // if(item.npi <= 0.9){
            // 	npiscore = parseFloat(item.npi).toFixed(1)*10;

            // }else{
            // 	npiscore = item.npi*10;
            // }

            // if(item.value <= 0.9){
            // 	valuescore = parseFloat(item.value).toFixed(1)*10;
            // }else{
            // 	valuescore = item.value*10;
            // }

            //valuescore = Math.round(item.value);
            if (ispage === "detailcity") {
              if (item.value) {
                valuescore = parseInt(item.value);

                if (valuescore) {
                  //valuescore = this.state.nhdetails[0].value;
                  valuescore = "$" + humanFormat(valuescore).replace(/\s/g, "");
                  valuescore = valuescore.replace(/-?\d+(\.\d+)?/g, (n) =>
                    Number(n).toFixed(0)
                  );
                  valuescore = valuescore.replace("-", "");

                  //valuescore = Number(((valuescore / 100) * 5).toFixed(2)).toFixed(1);
                }
              } else {
                valuescore = "-";
              }
            } else {
              if (item.value) {
                valuescore = "$" + parseInt(item.value).toLocaleString();
                //valuescore = Number(((item.value / 100) * 5).toFixed(2));
              } else {
                valuescore = "-";
              }
            }

            let displaykey = process.env.NEXT_PUBLIC_DISPLAY_DATA;

            const name = item.name;
            const location = item.label.split(",").slice(1).join(", ").trim();
            const fullTitle = `${name}, ${location}`;

            let reviewSummaryData = "";
            if (item.reviewSummary) {
              reviewSummaryData = customdecodeURIComponent(item.reviewSummary);
              reviewSummaryData = reviewSummaryData.slice(0, 85) + "..";
            }
            let neighborhoodimage = [];

            if (
              item.neighborhoodImages &&
              typeof item.neighborhoodImages === "string"
            ) {
              neighborhoodimage = JSON.parse(item.neighborhoodImages);
            } else {
              neighborhoodimage = item.neighborhoodImages;
            }

            return (
              <React.Fragment key={item.id || index}>
                {item[displaykey] && item[displaykey] === 1 ? (
                  <ItemData
                    id={item.id}
                    keydata={indexdataid}
                    href={href + item.nhfullname}
                    size={"small"}
                    source={
                      neighborhoodimage &&
                      neighborhoodimage.length > 0 &&
                      neighborhoodimage[0].thumbnailurl
                        ? neighborhoodimage[0].thumbnailurl
                        : process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/defaultnhmap.jpg"
                    }
                    head={
                      <div
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                        }}
                        title={fullTitle}
                      >
                        <span
                          style={{
                            fontSize: "18px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {name}
                        </span>
                        {location && (
                          <span
                            style={{
                              fontSize: "0.8em",

                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            , {location}
                          </span>
                        )}
                      </div>
                    }
                    subhead={item.npi ? "Overall Score : " + npiscore : null}
                    desc={item.value ? "Value: " + valuescore : null}
                    extra={reviewSummaryData ? reviewSummaryData : null}
                    header={header}
                    customclass={customclass}
                    ispage={ispage}
                    nhfullname={item.nhfullname}
                    // onClick={e => getData ? getData(e, item.head):e.preventDefault}
                  />
                ) : (
                  <ItemData
                    id={item.id}
                    keydata={indexdataid}
                    href=""
                    size={"small"}
                    source={
                      process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/defaultnhmap.jpg"
                    }
                    head={
                      <div
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                        }}
                        title={fullTitle}
                      >
                        <span
                          style={{
                            fontSize: "18px",

                            whiteSpace: "nowrap",
                          }}
                        >
                          {name}
                        </span>
                        {location && (
                          <span
                            style={{
                              fontSize: "0.8em",

                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            , {location}
                          </span>
                        )}
                      </div>
                    }
                    subhead="Comming soon"
                    desc=""
                    extra=""
                    header={header}
                    customclass={customclass}
                    ispage={ispage}
                    nhfullname={item.nhfullname}
                    // onClick={e => getData ? getData(e, item.head):e.preventDefault}
                  />
                )}
              </React.Fragment>
            );
          })}
        {itemData && itemData.length > 0 && (
          <Paginate
            length={data}
            prev={prev}
            active={active}
            isEnabled={isEnabled}
            seeFullListLink={seeFullListLink}
            {...props}
          />
        )}
      </Segment>
    </div>
  );
};

NeighborhoodsList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default NeighborhoodsList;
